/* eslint-disable max-len */

import { IIconProps } from 'types/models/Common';

// Иконка локаций в меню
export const LocationIcon = (props?: IIconProps) => {
  const renderContent = () => (
    <svg width={props?.size ?? 20} height={props?.size ?? 20} viewBox='0 0 20 20' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd' clipRule='evenodd' d='M3.12 7.94433C3.17143 4.19802 6.24865 1.20193 9.995 1.25058C13.7413 1.20193 16.8186 4.19802 16.87 7.94433C16.8684 9.39907 16.3849 10.8123 15.495 11.9631L9.995 20.0006L4.495 11.9631C3.6051 10.8123 3.12158 9.39907 3.12 7.94433ZM15.62 7.94433C15.5618 4.89131 13.0483 2.45877 9.995 2.50058C6.9417 2.45877 4.42817 4.89131 4.37 7.94433C4.36909 9.14569 4.77684 10.3116 5.52625 11.2506L9.995 17.7881L14.5012 11.2006C15.2266 10.2702 15.6203 9.12409 15.62 7.94433ZM10 6.25C11.0355 6.25 11.875 7.08947 11.875 8.125C11.875 9.16053 11.0355 10 10 10C8.96446 10 8.125 9.16053 8.125 8.125C8.125 7.08947 8.96446 6.25 10 6.25ZM6.875 8.125C6.875 6.39911 8.27411 5 10 5C11.7259 5 13.125 6.39911 13.125 8.125C13.125 9.85089 11.7259 11.25 10 11.25C8.27411 11.25 6.875 9.85089 6.875 8.125Z' fill='currentColor' />
    </svg>
  );

  return renderContent();
};
